var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSphereLayer2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 385"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-layer-2_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3E55",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80AFE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-layer-2_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932",
    stopOpacity: 0.388,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "sphere-layer-2_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081122",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487FCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "sphere-layer-2_svg__d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-layer-2_svg__a)",
    opacity: 0.752,
    x: 567,
    width: 164,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-layer-2_svg__b)",
    opacity: 0.484,
    x: 242,
    y: 378,
    width: 317,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.5 0C237.27 0 246 8.73 246 19.5S237.27 39 226.5 39h-42c-10.77 0-19.5-8.73-19.5-19.5S173.73 0 184.5 0h42zm0 3h-42c-9.113 0-16.5 7.387-16.5 16.5 0 9.005 7.215 16.326 16.18 16.497l.32.003h42c9.113 0 16.5-7.387 16.5-16.5 0-9.005-7.215-16.326-16.18-16.497L226.5 3z",
    fill: "#3C5475",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sphere-layer-2_svg__c)",
    opacity: 0.752,
    y: 10,
    width: 231,
    height: 21,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#80AFE5",
    filter: "url(#sphere-layer-2_svg__d)",
    cx: 221,
    cy: 20,
    r: 10
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgSphereLayer2 as ReactComponent };